import api from './axiosInstance';

export const loginApi          = (data)     => api.post('/login', data);
export const signupApi         = (formData) => api.post('/signup', formData);
export const resetPasswordApi  = (data)     => api.post('/reset-password', data);
export const updateProfileApi  = (formData) => api.post('/update-profile', formData);
